<template>
  <div>
    <div
      class="f-footer mtp"
      id="mainfooter1"
      :class="{ 'f-back': currentType == 'login' }"
    >
      <div class="clearFix"></div>
      <div
        class="footerTop wp"
        v-show="currentType != 'login'"
        style="overflow: inherit"
      >
        <!--<ul>-->
        <!--<li class="tLink">注册指南</li>-->
        <!--<li><a target="view_window" href="http://www.izhaowo.com/about/register#q2">新人注册</a></li>-->
        <!--<li><a target="view_window" href="http://www.izhaowo.com/about/register#q1">婚礼人注册</a></li>-->
        <!--</ul>-->
        <ul>
          <li class="tLink">在线预定</li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/appoint.html'"
              >定制流程</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/pay.html'">支付方式</a>
          </li>
          <!-- <li><a target="_blank" :href="curlurl2+'distance.html'">异地费,交通费标准</a></li> -->
        </ul>
        <ul>
          <li class="tLink">消费保障</li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/service.html#q1'"
              >实名认证</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/service.html#q2'"
              >定金担保</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/service.html#q3'"
              >价格透明</a
            >
          </li>
        </ul>
        <ul>
          <li class="tLink">售后服务</li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/aftersale.html#q1'"
              >无忧退款</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/aftersale.html#q2'"
              >应急服务</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/aftersale.html#q3'"
              >免费咨询</a
            >
          </li>
        </ul>

        <ul class="tLast">
          <li class="title">客服热线</li>
          <li class="tCon">4000-119-139</li>
          <li class="tCon" style="font-size: 14px; color: #999">
            周一至周日 9:00 - 18:30
          </li>
        </ul>
      </div>
      <div class="clearFix"></div>
      <div class="footerCenter wp" style="margin-top: 0px">
        <ul class="footerLink">
          <li>
            <a target="_blank" :href="curlurl2 + 'about/about.html'"
              >关于找我</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/contact.html'"
              >联系找我</a
            >
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/join.html'">加入找我</a>
          </li>
          <li>
            <a target="_blank" :href="curlurl2 + 'about/falv.html'">法律声明</a>
          </li>
          <li>
            <a target="_blank" :href="curlurl2">快速定制</a>
          </li>
        </ul>
        <p style="width: 260px; float: left">
          增值电信业务经营许可证：<i>川B2-20140181</i>&nbsp;&nbsp;&nbsp;
        </p>
        <div class="u-Vline"></div>
        <p style="width: 250px; display: inline; margin-left: 10px">
          &nbsp;&nbsp;&nbsp;© 2014 izhaowo.com <i>蜀ICP备14014073号</i>
        </p>
        <div class="f-foot-icon">
          <a class="foot-wx" @mouseover="getBar" @mouseout="getBar"></a>
          <span class="foot-gognzong" v-show="wxshow"
            ><!--<img class="" src="../../assets/images/gongzonghao.jpg" width="140" height="140"/>--></span
          >
          <a
            class="foot-wb"
            target="_blank"
            href="http://weibo.com/izhaowo"
          ></a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "../../config/api.js";
export default {
  name: "foot",
  props: ["type"],
  data: function () {
    return {
      wxshow: false,
      curlurl2: api.CURRENT_URL2,
      currentType: this.type,
    };
  },
  methods: {
    getBar: function () {
      this.wxshow = !this.wxshow;
    },
  },
};
</script>
<style scoped>
/*底部*/
* {
  font-size: 12px;
}
.f-footer {
  background: #f5f7f8;
  clear: both;
  position: relative;
  bottom: 0px;
  width: 100%;
}
.f-footer.f-back {
  background-color: #fff;
}
.f-footer .m-go-worker .f-go-worker {
  height: 68px;
  line-height: 68px;
  text-align: center;
  width: 1200px;
  border-bottom: 1px dashed #dadada;
  margin: 0 auto;
}
.f-footer .footerTop {
  position: relative;
  width: 1200px;
  margin: 0 auto;
  overflow: auto;
  height: 175px;
}
.f-footer .footerTop ul {
  width: 168px;
  padding: 14px 0;
  float: left;
  display: inline-block;
}
.f-footer li.tLink {
  color: #464646;
  font-size: 14px;
  height: 41px;
  line-height: 41px;
}
.f-footer .footerTop li {
  color: #464646;
  text-align: left;
  line-height: 34px;
}
.f-footer .footerTop li a {
  color: #979797;
}
.f-footer .footerTop ul.tLast {
  width: 165px;
  float: right;
}
.f-footer .footerTop ul.tLast .title {
  color: #979797;
  line-height: 14px;
}
.f-footer .footerTop ul.tLast .tCon {
  color: #464646;
  font-size: 24px;
}
.footerCenter {
  border-top: 1px dashed #dadada;
  margin: 25px auto 0px;
  padding: 15px 0px 20px 0px;
  color: #808080;
  position: relative;
  width: 1200px;
  overflow: inherit;
}
.f-footer .footerLink {
  display: block;
  height: 40px;
  line-height: 40px;
  text-align: left;
  overflow: hidden;
  width: 100%;
}
.f-footer .footerLink li {
  display: inline;
  margin-right: 25px;
}
.f-footer .footerLink li a {
  color: #464646;
}
.footerCenter p {
  color: #979797;
}
.footerCenter p i {
  color: #464646;
}
.f-foot-icon {
  position: absolute;
  right: 0px;
  top: 37px;
}
.f-foot-icon a {
  display: inline-block;
  margin-left: 26px;
  width: 26px;
  height: 26px;
  position: relative;
}
.f-foot-icon .foot-wx {
  background: url("../../assets/images/wechat_link_normal.png") no-repeat 0px
    0px;
}
.f-foot-icon .foot-wx:hover {
  background: url("../../assets/images/wechat_link_hover.png") no-repeat 0px 0px;
}
.f-foot-icon .foot-wb {
  background: url("../../assets/images/weibo_link_normal.png") no-repeat 0px 0px;
}
.f-foot-icon .foot-wb:hover {
  background: url("../../assets/images/weibo_link_hover.png") no-repeat 0px 0px;
}
.f-foot-icon .foot-gognzong {
  left: -60px;
  position: absolute;
  top: -150px;
  display: inline-block;
  width: 140px;
  height: 140px;
  border: 1px solid #cdcdcd;
  z-index: 100000;
  background: url("./icons/login_weixin.png") no-repeat;
  -webkit-background-size: 100% 100%;
  background-size: 100% 100%;
}
</style>



// WEBPACK FOOTER //
// foot-bar.vue?0c73ca69